import { css } from '@portal/styled-system/css'

import { getAssetUrl } from '@/shared/lib/cdn'

export function PlayThrobber() {
    return (
        <img
            src={getAssetUrl(`/assets/guiThrobber56.png`)}
            className={css({
                position: 'absolute',
                width: '[75px]',
                top: '[calc(50% - 32px)]',
                left: '[calc(50% - 32px)]',
                animation: 'spin',
            })}
            alt="Loading..."
        />
    )
}
